import React from "react";
import DOMPurify from "dompurify";

export const sanitizeAdditionalFieldHtml = (html) =>
  DOMPurify.sanitize(html || "");

export const AdditionalFieldHtml = ({ as: Component = "span", html, ...props }) => (
  <Component
    {...props}
    dangerouslySetInnerHTML={{
      __html: sanitizeAdditionalFieldHtml(html),
    }}
  />
);

export const AdditionalFieldLabel = ({ field, ...props }) => (
  <label {...props}>
    <AdditionalFieldHtml html={field?.fieldLabel} />
    {field?.required ? " *" : ""}
  </label>
);
